import React, { useCallback, useEffect, useRef, useState } from "react"
import { HexColorPicker } from "react-colorful"
import { FaFill } from "react-icons/fa"

import classes from "./EditorColorPicker.module.scss"

const defaultColors = ["#d0021b", "#f5a623", "#f8e71c", "#8b572a", "#7ed321", "#417505", "#bd10e0", "#9013fe", "#4a90e2", "#50e3c2", "#b8e986", "#000000", "#4a4a4a", "#9b9b9b", "#ffffff"]

const EditorColorPicker = (props) => {
  const { editor } = props

  const [color, setColor] = useState("#000000")
  const [showTextColorModal, setShowTextColorModal] = useState(false)
  const [showBackgroundColorModal, setShowBackgroundColorModal] = useState(false)

  const ref1 = useRef(null)
  const ref2 = useRef(null)

  const handleClickText = () => {
    const initialColorState =
      editor.getAttributes("textStyle").color || "#000000"

    setColor(initialColorState)

    setShowTextColorModal(prev => !prev)
  }

  const handleClickBack = () => {
    setShowBackgroundColorModal(prev => !prev)

    setColor("#000000")
  }

  const handleConfirmBackground = (color) => {
    editor.chain().focus().toggleHighlight({ color }).run()

    setColor(color)
  }

  const handleConfirmText = (color) => {
    editor.chain().focus().setColor(color).run()

    setColor(color)
  }

  const handleClickOutside = useCallback((e) => {
    if (!ref1.current?.contains(e.target)) {
      setShowBackgroundColorModal(false)
    }

    if (!ref2.current?.contains(e.target)) {
      setShowTextColorModal(false)
    }
  }, [])

  useEffect(() => {
    window.addEventListener("click", handleClickOutside)

    return () => {
      window.removeEventListener("click", handleClickOutside)
    }
  }, [])

  const barColor =
    editor.getAttributes("textStyle").color

  return (
    <div className={classes["container"]}>
      <div
        ref={ref1}
        className={classes["dropdown-container"]}
      >
        <button
          className={classes["button"]}
          onClick={handleClickBack}
        >
          <FaFill size={20} />
        </button>

        {
          showBackgroundColorModal &&
          <div className={classes["dropdown"]}>
            <div className={classes["squares"]}>
              {defaultColors.map(defaultColor =>
                <div
                  key={defaultColor}
                  style={{ backgroundColor: defaultColor }}
                  className={classes["square"]}
                  onClick={() => handleConfirmBackground(defaultColor)}
                />
              )}
            </div>
            <HexColorPicker
              color={color}
              onChange={handleConfirmBackground}
            />
          </div>
        }
      </div>

      <div
        ref={ref2}
        className={classes["dropdown-container"]}
      >
        <button
          className={classes["button"]}
          onClick={handleClickText}
        >
          <b style={{ fontSize: "18px" }}>A</b>
          {
            !!barColor &&
            <span
              style={{ backgroundColor: barColor }}
              className={classes["bar"]}
            />
          }
        </button>

        {
          showTextColorModal &&
          <div className={classes["dropdown"]}>
            <div className={classes["squares"]}>
              {defaultColors.map(defaultColor =>
                <div
                  key={defaultColor}
                  style={{ backgroundColor: defaultColor }}
                  className={classes["square"]}
                  onClick={() => handleConfirmText(defaultColor)}
                />
              )}
            </div>
            <HexColorPicker
              color={color}
              onChange={handleConfirmText}
            />
          </div>
        }
      </div>
    </div>
  )
}

export default EditorColorPicker